import { createBrowserRouter, Outlet, RouteObject, RouterProvider } from 'react-router';
import { privateRoutes } from './private-routes';
import { AppWrapperLayout, MainLayout } from '../../components/index.ts';
import { useAuthContext } from '../../assets/helpers/hooks/index.ts';
import React from 'react';
import { ErrorPage } from '@pages/index.ts';
import { Path } from '../../assets/enums/index.ts';
import {
  GamePage,
  GameSettingsPage,
  HomePage,
  PaymentMethodPage,
  PaymentSuccessPage,
  PhoneConfirmationPage,
  PhonePage, PostGamePage,
  StartGamePage,
} from '../../pages/index.ts';
import { HomeLayout } from '../../components/index.ts';
import { BettingLimitPage } from '../../pages/beeting-limit/index.ts';

const routesWithMainLayout = [
  { path: Path.GameSettings, element: <GameSettingsPage /> },
  { path: Path.Phone, element: <PhonePage /> },
  { path: Path.PhoneConfirmation, element: <PhoneConfirmationPage /> },
  { path: Path.PostGame, element: <PostGamePage /> },
];
// Public routes available to all users
const publicRoutes: RouteObject[] = [
  { path: Path.Home, element: <HomeLayout><HomePage /></HomeLayout> },
  { path: Path.StartGame, element: <HomeLayout><StartGamePage /></HomeLayout> },
  { path: Path.PaymentSuccess, element: <PaymentSuccessPage /> },
  { path: Path.PaymentMethod, element: <PaymentMethodPage /> },
  { path: Path.BettingLimit, element: <BettingLimitPage /> },
  { path: Path.Game, element: <GamePage /> },
];

routesWithMainLayout.forEach(route => publicRoutes.push({
  ...route,
  element: <MainLayout>{route.element}</MainLayout>,
}));

export const AuthChecker = () => {
  // const { isSuccess: isMeSuccess, isLoading: isIAmLoading } = useIAmQuery();
  // const { pathname } = useLocation();

  // const isLoading = isIAmLoading;

  // Show loader during initial data loading
  // if (isLoading) {
  //   return <BaseLayout><CircularLoaderWithContainer /></BaseLayout>;
  // }

  // if (isMeSuccess && pathname === Path.Login) {
  //   return <Navigate to={Path.Accounts} replace />;
  // }


  // Display the contents
  return <Outlet />;
};

const ProtectedRoutes = () => {
  const { isAuth } = useAuthContext();
  // return isAuth ? <Outlet /> : <Navigate to={Path.Login} replace />;
  return <Outlet />;
};

export const router = createBrowserRouter([
  {
    element: <AuthChecker />,
    children: [
      {
        element: <AppWrapperLayout />,
        children: publicRoutes,
      },
      {
        element: <ProtectedRoutes />,
        children: [
          {
            element: <MainLayout />,
            children: privateRoutes,
          },
        ],
      },
    ],
    errorElement: (
      <ErrorPage />
    ),
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}
